import { lazy } from 'react';

// project-imports
import Loadable from '@/components/base-component/Loadable';
import DashboardLayout from '@/layout/Dashboard';
import PagesLayout from '@/layout/Pages';
import { adminRoutes } from './route-auth/AdminRoutes';
import { reseachRoutes } from './route-auth/ReseachRoutes';
import { paymentRoutes } from './route-auth/PaymentRoutes';
import { maintainanceRoutes } from './route-public/MaintainanceRoutes';
import { reseachUserRoutes } from './route-auth/UserReseachRoutes';

const MaintenanceError = Loadable(lazy(() => import('@/pages/examples/maintenance/error/404')));

// ==============================|| SETUP ROUTES ||==============================
// APP ROOT PATH  ADMIN === /admin/{adminRoute}.......
// APP ROOT PATH  USER  === /user/{groupUserPath}/{userGroupRoute}.......
// groupUserPath เป็น group user เช่น /payment, /reseach, /administrative
// userGroupRoute เช่น PaymentRoute, ResearchRoute, AdministrativeRoute
//===============================================================================

// ==============================|| MAIN ROUTES ||============================== //
// ::: ROOT PATH URL เช่น http://localhost:3000/admin, http://localhost:3000/payment
// ::: ลำดับชั้นของ Path จะต้องเรียงลำดับให้ตรงในรายการ allowUsers List -->
// ::: ที่อยู่ของรายการ allowAdmins List ==> /src/components/menu-items/admins
// ::: ที่อยู่ของรายการ allowUsers List ==> /src/components/menu-items/users
const MainRoutes = {
  path: '/',
  children: [
    {
      path: '/', // *** assign default empty path ***
      element: <DashboardLayout />,
      children: adminRoutes
    },
    {
      path: '/admin',
      element: <DashboardLayout />,
      children: adminRoutes
    },
    {
      path: '/user/research',
      element: <DashboardLayout />,
      children: reseachRoutes
    },
    {
      path: '/user/payment',
      element: <DashboardLayout />,
      children: paymentRoutes
    },
    {
      path: '/user/latex-purchase',
      element: <DashboardLayout />,
      children: reseachUserRoutes
    },
    {
      path: '/user/maintenance',
      element: <PagesLayout />,
      children: maintainanceRoutes
    },
    { path: '*', element: <MaintenanceError /> }
  ]
};

export default MainRoutes;
